<template>
  <PageContainer title="Monitoramento das aulas teóricas">
    <div class="loading" v-if="!loaded">
      <LoadingSpinner />
    </div>

    <Box space="medium" v-else class="main-card">
      <form @submit.prevent="handleTurmasSubmit" class="main-form">
        <div class="inputs">
          <div class="inputs-row">
            <Select
              class="input-full"
              :options="schemaOptions"
              legend="Auto escola"
              placeholder="Selecione uma auto escola"
              :modelValue="schema"
              @update:modelValue="$event => (schema = $event)"
              :disabled="loadingTurmas"
            />

            <Select
              class="input-full"
              :options="turnoOptions"
              legend="Turno"
              placeholder="Selecione um turno"
              :modelValue="turno"
              @update:modelValue="$event => (turno = $event)"
              :disabled="loadingTurmas"
            />
          </div>

          <div class="buttons">
            <Button
              type="button"
              @handle:click="clearTurmasInputs"
              text="Limpar"
              :fill="false"
              color="danger"
              :disabled="loadingTurmas"
            >
              <CloseCircleOutline :size="18" />
            </Button>

            <Button type="submit" text="Consultar" color="primary" :disabled="loadingTurmas">
              <Magnify :size="18" />
            </Button>
          </div>
        </div>
      </form>

      <div class="loading" v-if="loadingTurmas">
        <LoadingSpinner />
      </div>

      <Table
        v-else-if="turmas.length"
        :headers="[
          'Agrupamento',
          'Início',
          'Fim',
          'Alunos regulares',
          'Alunos de reposição',
          'Alunos presentes',
          'Ações',
        ]"
      >
        <tr v-for="turma in turmas" :key="turma.id_turma_teorica">
          <td>{{ turma.id_agrupamento }}</td>
          <td>{{ turma.data_inicio.split(' ')[1] | DateBRFilter }}</td>
          <td>{{ turma.data_fim.split(' ')[1] | DateBRFilter }}</td>
          <td>{{ turma.quantidade_alunos || '-' }}</td>
          <td>{{ turma.reposicao_alunos.length }}</td>
          <td>
            {{
              turma.quantidade_alunos_presentes === null
                ? 'Sem presença de aluno registrada'
                : turma.quantidade_alunos_presentes
            }}
          </td>
          <td>
            <div class="actions">
              <div>
                <IconButton
                  @handle:click="getTurma(turma.id_turma_teorica, turma.id_agrupamento)"
                  color="primary"
                  title="Fotos"
                  :disabled="loadingTurmasActions"
                >
                  <ImageMultiple :size="19" />
                </IconButton>
              </div>
            </div>
          </td>
        </tr>
      </Table>

      <div class="loading" v-if="loadingTurma">
        <LoadingSpinner />
      </div>

      <template v-else-if="fotos.virtual">
        <div class="summary">
          <span>Total de alunos: {{ fotos.alunos.length }}</span>
          <span>Fotos esperadas: {{ fotos.alunos.length * 5 }}</span>
          <span>Fotos enviadas: {{ porcentagemTotal }}%</span>
        </div>

        <div class="photos-title">
          <h2>{{ turma.autoescola }}: {{ turma.agrupamento }}</h2>

          <Button
            type="button"
            @handle:click="getTurma(turma.id, turma.agrupamento)"
            text="Atualizar turma"
            color="secondary"
            :disabled="loadingTurma"
          >
            <Refresh :size="18" />
          </Button>
        </div>

        <FotosMonitoramento
          tab="pendentes"
          :entidade="instrutor"
          :showing="turma"
          @modalPhotos="modalPhotos"
          @modalReport="modalReport"
          :loading="loading"
        />

        <Tabs :options="['Irregular', 'Pendente', 'Conferido']">
          <div slot="Irregular" class="tab-content">
            <div v-for="aluno in alunosIrregulares" :key="aluno.cpf">
              <FotosMonitoramento
                tab="irregulares"
                :entidade="aluno"
                :showing="turma"
                @modalPhotos="modalPhotos"
                @modalReport="modalReport"
                @checkAluno="checkAluno"
                :loading="loading"
              />
            </div>
          </div>

          <div slot="Pendente" class="tab-content">
            <div v-for="aluno in alunosPendentes" :key="aluno.cpf">
              <FotosMonitoramento
                tab="pendentes"
                :entidade="aluno"
                :showing="turma"
                @modalPhotos="modalPhotos"
                @modalReport="modalReport"
                @checkAluno="checkAluno"
                :loading="loading"
              />
            </div>
          </div>

          <div slot="Conferido" class="tab-content">
            <div v-for="aluno in alunosConferidos" :key="aluno.cpf">
              <FotosMonitoramento
                tab="conferidos"
                :entidade="aluno"
                :showing="turma"
                @modalPhotos="modalPhotos"
                @modalReport="modalReport"
                :loading="loading"
              />
            </div>
          </div>
        </Tabs>
      </template>

      <div v-else>
        <div class="text-center" v-if="typeof fotos.virtual !== 'undefined' && !loadingPhotos">
          <hr />
          <h2>
            {{ turma.autoescola }}: {{ turma.agrupamento }}
            <button
              class="fa fa-refresh btn-micro btn-info"
              @click="loadPhotos(turma.id_turma_teorica)"
              title="atualizar fotos"
            ></button>
          </h2>
          <div class="col-md-12 mb-3 d-flex">
            <div class="col-md-6">
              <strong class="font-weight-bold">Monitor</strong>
              <span style="overflow: hidden" class="input-group-text mt-2">{{ monitor.nome }}</span>
            </div>
            <div class="col-md-3">
              <strong class="font-weight-bold">Primeiro registro</strong>
              <span style="overflow: hidden" class="input-group-text mt-2">{{
                monitor.inicio | DateBRFilter
              }}</span>
            </div>
            <div class="col-md-3">
              <strong class="font-weight-bold">Ultimo registro</strong>
              <span style="overflow: hidden" class="input-group-text mt-2">{{
                monitor.fim | DateBRFilter
              }}</span>
            </div>
          </div>
          <button
            type="button"
            @click="sendMonitoring(selectedUser)"
            class="btn btn-lg btn-block btn-primary"
            :disabled="btnNotificacao"
            title="Registrar monitoria"
          >
            MONITORANDO
          </button>
          <button
            type="button"
            @click="modalReport(turma)"
            class="btn btn-block btn-lg btn-danger"
            title="Reportar problema"
          >
            REPORTAR
          </button>
          <div
            class="card col"
            style="width: 18rem"
            v-for="arrayFotos in fotos.fotos"
            :key="arrayFotos.id_foto_teorica"
          >
            <img
              class="card-img-top"
              :src="'data:image/png;base64, ' + arrayFotos.imagem"
              :title="arrayFotos.tempo"
              alt="Falha ao carregar imagem"
            />
            <div class="card-body">
              <h5 class="card-title" style="white-space: nowrap; overflow: hidden !important">
                {{ arrayFotos.tempo.split(' ')[1] }}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </Box>

    <Modal ref="modalPhotos" title="Fotos">
      <div v-if="selectedUser.presencas && selectedUser.fotos" class="photos-modal">
        <div class="infos">
          <Input
            class="input-full"
            legend="Participante"
            :modelValue="selectedUser.participante"
            readonly
          />
          <Input
            class="input-full input-default"
            legend="Entrada"
            :modelValue="
              selectedUser.presencas.find(element => element.tipo == 0)
                ? selectedUser.presencas.find(element => element.tipo == 0).created_at.split(' ')[1]
                : 'Entrada não registrada'
            "
            readonly
          />
          <Input
            class="input-full input-default"
            legend="Intervalo"
            :modelValue="
              selectedUser.presencas.find(element => element.tipo == 2)
                ? selectedUser.presencas.find(element => element.tipo == 2).created_at.split(' ')[1]
                : 'Intervalo não registrado'
            "
            readonly
          />
          <Input
            class="input-full input-default"
            legend="Saída"
            :modelValue="
              selectedUser.presencas.find(element => element.tipo == 1)
                ? selectedUser.presencas.find(element => element.tipo == 1).created_at.split(' ')[1]
                : 'Saída não registrada'
            "
            readonly
          />
        </div>

        <div class="infos">
          <Input class="input-full" legend="Monitor" :modelValue="monitor.nome" readonly />
          <Input
            class="input-full input-default"
            legend="Primeiro Registro"
            :modelValue="monitor.inicio | DateBRFilter"
            readonly
          />
          <Input
            class="input-full input-default"
            legend="Último Registro"
            :modelValue="monitor.fim | DateBRFilter"
            readonly
          />
        </div>

        <div class="actions">
          <div v-if="deviceInfos" class="actions-row">
            <Input
              v-if="deviceInfos.apk_versao === 'Web'"
              class="input-full input-default"
              legend="Navegador"
              :modelValue="deviceInfos.dispositivo_nome"
              readonly
            />
            <Input
              v-else
              class="input-full input-default"
              legend="Versão APK"
              :modelValue="deviceInfos.apk_versao"
              readonly
            />
            <Input
              class="input-full input-default"
              legend="Sistema Operacional"
              :modelValue="deviceInfos.so"
              readonly
            />
          </div>

          <div class="actions-row">
            <Button
              type="button"
              @handle:click="
                sendMonitoring(
                  selectedUser,
                  selectedUser.presencas.find(element => element.tipo == 0).entidade
                )
              "
              text="Monitorando"
              color="secondary"
            >
              <Refresh :size="18" />
            </Button>
            <Button
              type="button"
              @handle:click="requestPhotos(selectedUser)"
              text="Capturar imagem do aluno"
              color="primary"
              :fill="false"
            >
              <Camera :size="18" />
            </Button>
          </div>
        </div>

        <div class="photos">
          <img :src="'data:image/jpeg;base64, ' + selectedUser.perfil" />

          <div class="photos-content">
            <div class="photos-list">
              <div class="list">
                <div v-for="(user, index) in selectedUser.fotos" :key="user.id_foto_teorica">
                  <img
                    :src="'data:image/jpeg;base64, ' + user.imagem"
                    :title="user.tempo.split(' ')[1]"
                  />
                </div>
              </div>

              <Button
                type="button"
                @handle:click="
                  getMorePhotos(
                    turma.autoescola,
                    turma.id,
                    selectedUser.id,
                    selectedUser.fotos.map(item => item.id_foto_teorica)
                  )
                "
                text="Carregar mais"
                color="primary"
              >
                <Plus :size="18" />
              </Button>
            </div>

            <div class="notifications">
              <Select
                class="input-full"
                :options="notificacoes"
                legend="Notificação"
                placeholder="Selecione uma notificação"
                :modelValue="idNotificacao"
                @update:modelValue="$event => (idNotificacao = $event)"
              />

              <Button
                type="button"
                @handle:click="notificarAluno(selectedUser.cpf)"
                text="Confirmar notificação"
                color="primary"
                :disabled="!selectedUser.presencas.find(element => element.tipo == 0)"
              >
                <Check :size="18" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>

    <Modal ref="modalReport" title="Reportar Problema">
      <div class="report-modal">
        <div class="summary" v-if="turma">
          <span>{{ report.participante ? report.participante : report.autoescola }}</span>
          <span>{{ report.agrupamento }}</span>
        </div>

        <div class="infos">
          <Input class="input-full" legend="Monitor" :modelValue="monitor.nome" readonly />

          <Input
            class="input-full"
            legend="Primeiro registro"
            :modelValue="monitor.inicio | DateBRFilter"
            readonly
          />

          <Input
            class="input-full"
            legend="Primeiro registro"
            :modelValue="monitor.fim | DateBRFilter"
            readonly
          />
        </div>

        <div>
          <RadioButtons
            :options="radioOptions"
            name="problem"
            :modelValue="report.tipo_report"
            @update:modelValue="$event => (this.report.tipo_report = $event)"
          />
        </div>

        <Textarea
          legend="Informe a decisão tomada"
          @update:modelValue="$event => (this.report.observacao = $event)"
          :modelValue="report.observacao"
          placeholder="Atitudes tomadas (limite de 255 caracteres)"
          class="input-full"
        />

        <div class="buttons">
          <Button
            type="button"
            @handle:click="sendReport(report)"
            text="Enviar reporte"
            color="danger"
          >
            <CloseCircleOutline :size="18" />
          </Button>
        </div>
      </div>
    </Modal>

    <!-- <vuestic-modal id="modalPhotos" v-bind:large="true" :cancelClass="'none'" :okClass="'none'">
        <div class="row" v-if="selectedUser.presencas && selectedUser.fotos">
          <div class="col-md-12 mb-3 d-flex">
            <div class="col-md-3">
              <strong class="font-weight-bold">Participante</strong>
              <span style="overflow: hidden" class="input-group-text mt-2">{{
                selectedUser.participante
              }}</span>
            </div>
            <div class="col-md-3">
              <strong class="font-weight-bold">ENTRADA</strong>
              <span style="overflow: hidden" class="input-group-text mt-2"
                >{{
                  selectedUser.presencas.find(element => element.tipo == 0)
                    ? selectedUser.presencas
                        .find(element => element.tipo == 0)
                        .created_at.split(' ')[1]
                    : 'Entrada não registrada'
                }}
              </span>
            </div>
            <div class="col-md-3">
              <strong class="font-weight-bold">INTERVALO</strong>
              <span style="overflow: hidden" class="input-group-text mt-2"
                >{{
                  selectedUser.presencas.find(element => element.tipo == 2)
                    ? selectedUser.presencas
                        .find(element => element.tipo == 2)
                        .created_at.split(' ')[1]
                    : 'Intervalo não registrado'
                }}
              </span>
            </div>
            <div class="col-md-3">
              <strong class="font-weight-bold">SAÍDA</strong>
              <span style="overflow: hidden" class="input-group-text mt-2"
                >{{
                  selectedUser.presencas.find(element => element.tipo == 1)
                    ? selectedUser.presencas
                        .find(element => element.tipo == 1)
                        .created_at.split(' ')[1]
                    : 'Saída não registrada'
                }}
              </span>
            </div>
          </div>

          <div class="col-md-12 mb-3 d-flex">
            <div class="col-md-6">
              <strong class="font-weight-bold">Monitor</strong>
              <span style="overflow: hidden" class="input-group-text mt-2">{{ monitor.nome }}</span>
            </div>
            <div class="col-md-3">
              <strong class="font-weight-bold">Primeiro registro</strong>
              <span style="overflow: hidden" class="input-group-text mt-2">{{
                monitor.inicio | DateBRFilter
              }}</span>
            </div>
            <div class="col-md-3">
              <strong class="font-weight-bold">Ultimo registro</strong>
              <span style="overflow: hidden" class="input-group-text mt-2">{{
                monitor.fim | DateBRFilter
              }}</span>
            </div>
          </div>

          <div class="col-md-12 mb-3 d-flex" v-if="deviceInfos">
            <template v-if="deviceInfos.apk_versao === 'Web'">
              <div class="col-md-3">
                <strong class="font-weight-bold">Navegador</strong>
                <span style="overflow: hidden" class="input-group-text mt-2">{{
                  deviceInfos.dispositivo_nome
                }}</span>
              </div>
              <div class="col-md-3">
                <strong class="font-weight-bold">Sistema Operacional</strong>
                <span style="overflow: hidden" class="input-group-text mt-2">{{
                  deviceInfos.so
                }}</span>
              </div>
            </template>

            <template v-else>
              <div class="col-md-3">
                <strong class="font-weight-bold">Versão APK</strong>
                <span style="overflow: hidden" class="input-group-text mt-2">{{
                  deviceInfos.apk_versao
                }}</span>
              </div>
              <div class="col-md-3">
                <strong class="font-weight-bold">Sistema Operacional</strong>
                <span style="overflow: hidden" class="input-group-text mt-2">{{
                  deviceInfos.so
                }}</span>
              </div>
            </template>
          </div>

          <div class="col-md-12 d-flex">
            <div class="col-md-7 mt-3 text-center">
              <div style="max-height: 400px; overflow: auto">
                <span
                  class="mr-1 ml-1 text-center"
                  v-for="(user, index) in selectedUser.fotos"
                  :key="user.id_foto_teorica"
                >
                  <img
                    class="img-thumbnail mt-2 mb-2"
                    style="width: 160px; height: 160px; cursor: pointer"
                    :src="'data:image/jpeg;base64, ' + user.imagem"
                    :title="user.tempo.split(' ')[1]"
                    alt="Falha ao carregar imagem"
                  />
                </span>
                <div class="r-1 ml-1 text-center" v-if="btnMorePhotos">
                  <button
                    type="button"
                    class="btn-primary btn-block"
                    title="Ver mais fotos"
                    @click="
                      getMorePhotos(
                        showing.autoescola,
                        showing.id_turma_teorica,
                        selectedUser.id,
                        selectedUser.fotos.map(item => item.id_foto_teorica)
                      )
                    "
                  >
                    Carregar mais fotos
                  </button>
                </div>
                <div class="d-flex justify-content-center" v-else>
                  <component
                    :animation-duration="1000"
                    :is="'SpringSpinner'"
                    :color="'#4AE387'"
                    :size="80"
                  >
                  </component>
                </div>
              </div>
              <div style="display: flex" class="mt-3">
                <div class="col-md-6"></div>
                <div class="col-md-6 text-right">
                  <span class="badge bg-secondary">{{ selectedUser.fotos.length }}</span>
                </div>
              </div>
              <hr />
              <button
                type="button"
                class="btn btn-lg btn-block btn-primary"
                :disabled="
                  !selectedUser.presencas.find(element => element.tipo == 0) || btnNotificacao
                "
                @click="
                  sendMonitoring(
                    selectedUser,
                    selectedUser.presencas.find(element => element.tipo == 0).entidade
                  )
                "
                title="Registrar monitoria"
              >
                MONITORANDo
              </button>
            </div>
            <div class="col-md-5 text-center">
              <span>
                <img
                  class="img-thumbnail mt-2 mb-2"
                  style="width: auto; height: 400px"
                  :src="'data:image/jpeg;base64, ' + selectedUser.perfil"
                />
              </span>
              <div id="acoes" class="mt-3">
                <select class="form-control mb-2 input-bordered" v-model="idNotificacao">
                  <option disabled value="default" selected>Selecione uma notificação</option>
                  <option
                    v-for="notificacao in notificacoes"
                    :value="notificacao.value"
                    :key="notificacao.value"
                  >
                    {{ notificacao.title }}
                  </option>
                </select>
                <span
                  class="mr-2 btn-lg btn-block btn-primary"
                  :disabled="!selectedUser.presencas.find(element => element.tipo == 0)"
                  title="Notificar aluno"
                  @click="notificarAluno(selectedUser.cpf)"
                >
                  <a>
                    <i class="fa fa-bell"></i>
                  </a>
                </span>
                <button
                  class="mr-2 btn-lg btn-block btn-info"
                  :disabled="
                    !selectedUser.presencas.find(element => element.tipo == 0) || btnRequisicaoFoto
                  "
                  title="Notificar aluno"
                  @click="requestPhotos(selectedUser)"
                >
                  <a> CAPTURAR IMAGEM DO ALUNO </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      </vuestic-modal> -->

    <!-- <vuestic-modal
        ref="modalReport"
        id="modalReport"
        v-bind:large="true"
        :cancelClass="'none'"
        :okClass="'none'"
      >
        <span slot="title">Reportar Problema</span>
        <div class="col-md-12 mb-3 d-flex">
          <div class="col-md-6">
            <strong class="font-weight-bold">Monitor</strong>
            <span style="overflow: hidden" class="input-group-text mt-2">{{ monitor.nome }}</span>
          </div>
          <div class="col-md-3">
            <strong class="font-weight-bold">Primeiro registro</strong>
            <span style="overflow: hidden" class="input-group-text mt-2">{{
              monitor.inicio | DateBRFilter
            }}</span>
          </div>
          <div class="col-md-3">
            <strong class="font-weight-bold">Ultimo registro</strong>
            <span style="overflow: hidden" class="input-group-text mt-2">{{
              monitor.fim | DateBRFilter
            }}</span>
          </div>
        </div>
        <div class="container text-center">
          <div class="row">
            <div class="col-sm">
              {{ report.participante ? report.participante : report.autoescola }}
            </div>
            <div class="col-sm">
              {{ report.agrupamento }}
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm">
              <input
                class="form-check-input"
                id="semRosto"
                type="radio"
                name="problem"
                value="2"
                v-model="report.tipo_report"
              />
              <label class="form-check-label" for="semRosto">
                Candidato ou instrutor não está presente nas fotos.
              </label>
            </div>
            <div class="col-sm">
              <input
                class="form-check-input"
                id="invalida"
                type="radio"
                name="problem"
                value="3"
                v-model="report.tipo_report"
              />
              <label class="form-check-label" for="invalida">
                Fotos ilegíveis (ex:escuras ou que impossibilitem o reconhecimento facial).
              </label>
            </div>
            <div class="col-sm">
              <input
                class="form-check-input"
                id="impropria"
                type="radio"
                name="problem"
                value="4"
                v-model="report.tipo_report"
              />
              <label class="form-check-label" for="impropria">
                Registro de fotos impróprias ou de cunho sexual.
              </label>
            </div>
            <div class="col-sm">
              <input
                class="form-check-input"
                id="semFoto"
                type="radio"
                name="problem"
                value="5"
                v-model="report.tipo_report"
              />
              <label class="form-check-label" for="semFoto"> Sem fotos registradas. </label>
            </div>
          </div>
          <hr />
          <div class="row">
            <legend>Informe que atitude foi tomada</legend>
            <textarea
              class="form-control card"
              placeholder="Atitudes tomadas (limite de 255 caracteres)"
              maxlength="255"
              v-model="report.observacao"
            ></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button
              type="button"
              class="btn btn-danger btn-block btn-lg"
              :disabled="btnNotificacao"
              @click="sendReport(report)"
            >
              ENVIAR
            </button>
          </slot>
        </div>
      </vuestic-modal> -->
  </PageContainer>
</template>

<script>
import Box from 'core/Box'
import Button from 'core/Button'
import IconButton from 'core/IconButton'
import Input from 'core/Input'
import LoadingSpinner from 'core/LoadingSpinner'
import Modal from 'core/Modal'
import PageContainer from 'core/PageContainer'
import RadioButtons from 'core/RadioButtons'
import Select from 'core/Select'
import Table from 'core/Table'
import Tabs from 'core/Tabs'
import Textarea from 'core/Textarea'
import Camera from 'icons/Camera'
import Check from 'icons/Check'
import CloseCircleOutline from 'icons/CloseCircleOutline'
import ImageMultiple from 'icons/ImageMultiple'
import Magnify from 'icons/Magnify'
import Plus from 'icons/Plus'
import Refresh from 'icons/Refresh'

import * as spinners from 'epic-spinners'
import { ModelSelect } from 'vue-search-select'
import urlApi from '../../../router/urlApiV2'
import FotosMonitoramento from './FotosMonitoramento.vue'
import TeoricasController from './TeoricasController'

export default {
  name: 'MonitoramentoFotosTeoricas',
  components: {
    PageContainer,
    Box,
    Button,
    LoadingSpinner,
    Select,
    IconButton,
    Table,
    Tabs,
    Modal,
    Input,
    RadioButtons,
    Textarea,

    CloseCircleOutline,
    Magnify,
    ImageMultiple,
    Refresh,
    Camera,
    Plus,
    Check,

    ModelSelect,
    ...spinners,
    FotosMonitoramento,
  },
  data() {
    return {
      schema: null,
      turno: null,
      turma: null,
      instrutor: null,
      radioOptions: [
        { value: '2', label: 'O candidato ou instrutor não aparece nas fotos.' },
        {
          value: '3',
          label: 'Imagens escuras ou desfocadas que impeçam a identificação do rosto.',
        },
        { value: '4', label: 'Registro de imagens inapropriadas ou de teor sexual.' },
        { value: '5', label: 'Nenhuma foto registrada.' },
      ],
      schemaOptions: [],
      turnoOptions: [
        { value: 0, text: 'Manhã' },
        { value: 1, text: 'Tarde' },
        { value: 2, text: 'Noite' },
      ],
      turmas: [],
      fotos: [],
      alunosIrregulares: [],
      alunosPendentes: [],
      alunosConferidos: [],
      loaded: false,
      loadingTurmas: false,
      loadingTurmasActions: false,
      loadingTurma: false,

      imageCheck: false,
      imageModal: 'image-check',
      selectCFC: [],
      selectedCFC: null,
      showing: [],
      loadTable: false,
      loadingPhotos: false,
      loadedClasses: 0,
      tbTurmas: [],

      selectPeriodo: [
        { value: 0, text: 'Manhã' },
        { value: 1, text: 'Tarde' },
        { value: 2, text: 'Noite' },
      ],
      selectedPeriodo: null,
      selectedUser: [],
      report: [],
      monitor: { nome: null, inicio: null, fim: null },
      btnNotificacao: false,
      btnRequisicaoFoto: false,
      btnMorePhotos: true,
      idNotificacao: 'default',
      notificacoes: [
        {
          value: 0,
          text: 'Aluno fora de foco',
          title: 'Aluno fora de foco',
        },
        {
          value: 1,
          text: 'Tela preta',
          title: 'Tela preta',
        },
      ],
      loading: false,
      deviceInfos: null,
    }
  },
  async created() {
    await this.fetchCfcs()

    this.loaded = true
  },
  mounted() {
    TeoricasController.startTime()
    // CARREGAR CFC's
    TeoricasController.loadCfc().then(res => {
      this.selectCFC = []
      this.selectCFC = res
    })

    document.addEventListener('keydown', this.keyUpHandler)
  },
  destroyed() {
    document.removeEventListener('keydown', this.keyUpHandler)
  },
  methods: {
    async fetchCfcs() {
      await this.$http
        .get(`${process.env.VUE_APP_URL_API_V2}/autoescola/todas`)
        .then(res => {
          this.schemaOptions = res.body.dados.map(cfc => ({
            value: cfc.tenant_schema,
            text: cfc.nome_fantasia,
          }))
        })
        .catch(error => {
          this.$toasted.show('Erro!' + error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    clearTurmasInputs() {
      this.schema = null
      this.turno = null
    },
    async handleTurmasSubmit() {
      if (this.validateTurmasInputs()) {
        await this.fetchTurmas()
      }
    },
    validateTurmasInputs() {
      if (!this.schema || ![0, 1, 2].includes(this.turno)) {
        this.$toasted.show('Preencha todos os campos corretamente.', {
          icon: 'fa-warning',
          position: 'top-right',
          duration: 5000,
          fullWidth: false,
        })

        return false
      }

      return true
    },
    async fetchTurmas() {
      this.loadingTurmas = true

      const params = {
        schema: this.schema,
        periodo: this.turno,
      }

      await this.$http
        .get(`${process.env.VUE_APP_URL_API_V2}/aulas/teoricas/monitoramento`, {
          params,
        })
        .then(({ body }) => {
          const dados = body.dados

          if (!dados.length) {
            this.$toasted.show('Sem resultados para sua pesquisa.', {
              icon: 'fa-warning',
              position: 'top-right',
              duration: 5000,
              fullWidth: false,
            })

            return
          }

          this.turmas = dados
        })
        .catch(err => {
          console.log(err)
          this.$toasted.show(err.body.mensagem, {
            icon: 'fa-warning',
            position: 'top-right',
            duration: 5000,
            fullWidth: false,
          })
        })
        .finally(() => {
          this.loadingTurmas = false
        })
    },
    async getTurma(id, agrupamento) {
      this.loadingTurma = true

      if (this.turma) {
        Echo.leave(`Monitoramento.Fotos.${this.turma.agrupamento}`)

        if (this.turmas[0].virtual) {
          Echo.leave(`Status.Monitoramento.${this.turma.id_turma_teorica}`)
        }
      }

      const params = {
        schema: this.schema,
        turma: id,
      }

      await this.$http
        .get(`${process.env.VUE_APP_URL_API_V2}/aulas/teoricas/monitoramento/fotos`, {
          params,
        })
        .then(({ body }) => {
          const dados = body.dados

          if (dados.virtual) {
            this.setPhotos(dados)
          } else {
            this.fotos = dados
          }

          this.turma = {
            autoescola: this.schemaOptions.find(schema => schema.value == this.schema).text,
            schema: this.schema,
            id,
            agrupamento,
          }

          this.receivePhoto(this.turma)

          if (dados.virtual) {
            this.changeStatusMonitoramento(id)
          }
        })
        .catch(err => {
          this.$toasted.show(err.body.mensagem, {
            icon: 'fa-warning',
            position: 'top-right',
            duration: 5000,
            fullWidth: false,
          })
        })
        .finally(() => {
          this.loadingTurma = false
        })
    },
    setPhotos(data) {
      this.alunosIrregulares = []
      this.alunosPendentes = []
      this.alunosConferidos = []

      this.fotos = data
      this.instrutor = data.instrutor

      data.alunos.map(item => {
        switch (item.statusMonitoramento) {
          case undefined:
          case null:
          case 'irregular':
            this.alunosIrregulares.push(item)
            break
          case 'pendente':
            this.alunosPendentes.push(item)
            break
          case 'conferido':
            this.alunosConferidos.push(item)
            break
        }
      })
    },
    receivePhoto(agrupamento) {
      Echo.private(`Monitoramento.Fotos.${agrupamento.agrupamento}`)
        .listen('.GetPhoto', event => {
          this.$toasted.show(
            'Foto recebida! Candidato: ' +
              this.fotos.alunos.filter(element => element.cpf == event.photo.alunos.cpf)[0].aluno,
            {
              position: 'top-right',
            }
          )

          this.fotos.alunos
            .filter(element => element.cpf == event.photo.alunos.cpf)[0]
            .fotos.unshift(event.photo.alunos)
        })
        .listen('.GetMorePhotos', event => {
          console.log(event.photo.length)
          if (event.photo == 0) {
            this.$toasted.show('Não há mais fotos!', {
              position: 'top-right',
            })
            this.btnMorePhotos = true
            return
          }
          this.fotos.alunos.filter(element => element.cpf == event.photo[0].cpf)[0].fotos =
            this.fotos.alunos
              .filter(element => element.cpf == event.photo[0].cpf)[0]
              .fotos.concat(event.photo)
          this.modalPhotos(
            this.fotos.alunos.filter(element => element.cpf == event.photo[0].cpf)[0]
          )
          this.btnMorePhotos = true
        })
    },
    changeStatusMonitoramento(idTurmaTeorica) {
      Echo.private(`Status.Monitoramento.${idTurmaTeorica}`).listen(
        '.ChangeStatusMonitoramento',
        event => {
          const result = event.status
          console.log('1', result)
          console.log('2', event.fromStatus)
          const index = this.addAlunoFromList(
            result.oldStatus,
            result.status.id_entidade,
            event.fromStatus
          )
          this.removeAlunoFromList(result.oldStatus, index)

          this.$toasted.show(
            'Status Atualizado! Candidato: ' +
              this.fotos.alunos.find(aluno => aluno.presencas[0].id === result.status.id_entidade)
                .aluno,
            {
              position: 'top-right',
            }
          )
        }
      )
    },
    modalPhotos(photos) {
      this.idNotificacao = 'default'

      this.deviceInfos = null

      this.selectedUser = {
        id: photos.id,
        participante: photos.aluno ? photos.aluno : photos.instrutor,
        cpf: photos.cpf,
        fotos: photos.fotos,
        perfil: photos.perfil,
        presencas: photos.presencas,
      }

      this.getMonitor({ tipo: photos.aluno ? 'ALUNO' : 'INSTRUTOR', cpf: photos.cpf })

      if (photos.presencas.length > 0) {
        this.getDeviceInfos(photos.aluno ? 'ALUNO' : 'INSTRUTOR', photos.presencas[0].id)
      }

      this.$refs.modalPhotos.open()
    },
    getMonitor(participante = null) {
      this.monitor = {
        nome: 'carregando os dados . . .',
        inicio: '...',
        fim: '...',
      }

      let $param =
        participante !== null
          ? `schema=${this.turma.schema}&turma=${this.turma.id}&entidade=${participante.tipo}&cpf=${participante.cpf}`
          : `schema=${this.turma.schema}&turma=${this.turma.id}`

      this.$http
        .get(urlApi + `/aulas/teoricas/notificacao/consultar/monitor?${$param}`)
        .then(response => {
          if (response.body.dados == null) {
            this.monitor = {
              nome: 'Sem registro de monitoria',
              inicio: 'xx:xx:xx',
              fim: 'xx:xx:xx',
            }
            return
          }

          this.monitor = {
            nome: response.body.dados.usuario.nome,
            inicio: response.body.dados.notificacoes[0].created_at,
            fim: response.body.dados.notificacoes[response.body.dados.notificacoes.length - 1]
              .created_at,
          }
        })
        .catch(error => {
          this.$toasted.show(error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async getDeviceInfos(entidade, idEntidade) {
      const data = {
        schema: this.turma.schema,
        idTurmaTeorica: this.turma.id,
        entidade,
        idEntidade,
      }

      await this.$http
        .post(`${urlApi}/aulas/teoricas/alunos/device-infos`, data)
        .then(response => {
          this.deviceInfos = response.body.dados
        })
        .catch(() => {
          this.deviceInfos = null
        })
    },
    sendMonitoring(dados, tipo = null) {
      this.btnNotificacao = true
      let report = {
        autoescola: this.turma.autoescola,
        schema: this.turma.schema,
        id_turma: this.turma.id,
        agrupamento: this.turma.agrupamento,
        cpf: dados.cpf ? dados.cpf : null,
        tipo: tipo,
        tipo_report: 1,
        observacao: null,
      }
      this.$http
        .post(urlApi + '/aulas/teoricas/notificacao/fotos', report)
        .then(response => {
          this.$toasted.show(response.body.mensagem, {
            position: 'top-right',
          })
          this.btnNotificacao = false
          this.getMonitor(report)
        })
        .catch(error => {
          this.btnNotificacao = false
          this.$toasted.show(error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    requestPhotos(aluno) {
      this.btnRequisicaoFoto = true
      this.$http
        .get(urlApi + `/turmas/capturar-foto/aluno?cpf=${aluno.cpf}&schema=${this.schema}`)
        .then(response => {
          this.btnRequisicaoFoto = false
          this.$toasted.show(response.body.mensagem, {
            position: 'top-right',
          })
        })
        .catch(error => {
          this.btnRequisicaoFoto = false
          this.$toasted.show(error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async checkAluno(aluno, anomalia) {
      if (!aluno) {
        return this.$toasted.show('Aluno não encontrado!', {
          position: 'top-right',
        })
      }

      this.loading = true

      const data = {
        schema: this.turma.schema,
        idTurmaTeorica: this.turma.id,
        entidade: 'ALUNO',
        idEntidade: aluno.presencas[0].id,
        status: 'conferido',
        anomalia,
      }

      await this.$http
        .post(`${urlApi}/aulas/teoricas/monitoramento/change-status`, data)
        .then(() => {
          this.loading = false
        })
        .catch(err => {
          this.$toasted.show(err.body.dados, {
            position: 'top-right',
          })

          console.log(err)

          this.loading = false
        })
    },
    sendReport(dados) {
      this.btnNotificacao = true
      if (dados.tipo_report == null || dados.observacao == null) {
        this.$toasted.show('Necessário selecionar o problema e descrever o que foi feito!', {
          position: 'top-right',
        })
        this.btnNotificacao = false
        return
      } else if (dados.observacao.trim().length < 5) {
        this.$toasted.show('Obeservação deve conter no mínimo 5 caracteres!', {
          position: 'top-right',
        })
        this.btnNotificacao = false
        return
      }
      this.$http
        .post(urlApi + '/aulas/teoricas/notificacao/fotos', dados)
        .then(response => {
          this.$toasted.show(response.body.mensagem, {
            position: 'top-right',
          })
          this.btnNotificacao = false
          this.getMonitor(dados)

          this.$refs.modalReport.close()
        })
        .catch(error => {
          this.btnNotificacao = false
          this.$toasted.show(error.body.mensagem, {
            position: 'top-right',
          })
          this.$refs.modalReport.close()
        })
    },
    removeAlunoFromList(list, alunoIndex) {
      if (list === 'irregular') {
        const newArr = this.alunosIrregulares.filter((item, index) => index !== alunoIndex)
        this.alunosIrregulares = newArr
      } else {
        const newArr = this.alunosPendentes.filter((item, index) => index !== alunoIndex)
        this.alunosPendentes = newArr
      }
    },
    addAlunoFromList(list, alunoId, fromStatus) {
      let alunoIndex = null

      if (list === 'irregular') {
        alunoIndex = this.alunosIrregulares.findIndex(item => item.presencas[0].id === alunoId)

        if (fromStatus === 'pendente') {
          this.alunosPendentes.push(this.alunosIrregulares[alunoIndex])
        } else {
          this.alunosConferidos.push(this.alunosIrregulares[alunoIndex])
        }
      } else {
        alunoIndex = this.alunosPendentes.findIndex(item => item.presencas[0].id === alunoId)
        this.alunosConferidos.push(this.alunosPendentes[alunoIndex])
      }

      return alunoIndex
    },
    notificarAluno(cpf) {
      if (this.idNotificacao == 'default') {
        this.$toasted.show('Selecione um tipo de notificação.', {
          position: 'top-right',
        })
      } else {
        let data = {
          cpf: cpf,
          idNotificacao: this.idNotificacao,
        }

        this.$http
          .post(urlApi + '/push/notify-student', data)
          .then(response => {
            this.$toasted.show(response.body.msg, {
              position: 'top-right',
            })
          })
          .catch(error => {
            this.$toasted.show(error.body.mensagem, {
              position: 'top-right',
            })
          })
      }
    },
    modalReport(aula, participante = null, tipo = null) {
      this.report = []
      console.log(aula)
      if (participante === null) {
        this.report = {
          autoescola: aula.autoescola,
          schema: aula.schema,
          id_turma: aula.id,
          agrupamento: aula.agrupamento,
          tipo_report: null,
          observacao: null,
        }
        this.getMonitor()
      } else {
        this.report = {
          autoescola: aula.autoescola,
          schema: aula.schema,
          id_turma: aula.id,
          agrupamento: aula.agrupamento,
          cpf: participante.cpf,
          tipo: tipo,
          tipo_report: null,
          observacao: null,
        }
        this.getMonitor(this.report)
      }
      this.$refs.modalReport.open()
    },
    getMorePhotos(autoescola, id_turma_teorica, userId, ids_foto_teorica) {
      this.btnMorePhotos = false
      TeoricasController.getMorePhotos(
        data => {
          //
        },
        autoescola.toLowerCase().replace(/\s/g, ''),
        id_turma_teorica,
        userId,
        ids_foto_teorica
      )
    },
    keyUpHandler(event) {
      const tab = this.$refs.tabs

      if (tab && tab.currentActive === 'Irregulares' && !this.loading) {
        if (event.keyCode === 37 && event.ctrlKey) {
          this.checkAluno(this.alunosIrregulares[0], true)
        } else if (event.keyCode === 39 && event.ctrlKey) {
          this.checkAluno(this.alunosIrregulares[0], false)
        }
      } else if (tab && tab.currentActive === 'Pendentes' && !this.loading) {
        if (event.keyCode === 37 && event.ctrlKey) {
          this.checkAluno(this.alunosPendentes[0], true)
        } else if (event.keyCode === 39 && event.ctrlKey) {
          this.checkAluno(this.alunosPendentes[0], false)
        }
      }
    },
    changeStatusMonitoramento(idTurmaTeorica) {
      Echo.private(`Status.Monitoramento.${idTurmaTeorica}`).listen(
        '.ChangeStatusMonitoramento',
        event => {
          const result = event.status
          console.log('1', result)
          console.log('2', event.fromStatus)
          const index = this.addAlunoFromList(
            result.oldStatus,
            result.status.id_entidade,
            event.fromStatus
          )
          this.removeAlunoFromList(result.oldStatus, index)

          this.$toasted.show(
            'Status Atualizado! Candidato: ' +
              this.fotos.alunos.find(aluno => aluno.presencas[0].id === result.status.id_entidade)
                .aluno,
            {
              position: 'top-right',
            }
          )
        }
      )
    },
  },
  computed: {
    porcentagemTotal() {
      const totalFotos = this.fotos.alunos.reduce((total, aluno) => {
        return total + Math.min(aluno.fotos.length, 5)
      }, 0)

      const totalPossivel = this.fotos.alunos.length * 5
      return (totalFotos / totalPossivel) * 100
    },
  },
  beforeDestroy() {
    Echo.leave(`Monitoramento.Fotos.${this.turma.agrupamento}`)
    Echo.leave(`Status.Monitoramento.${this.turma.id}`)
  },
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.input-full {
  flex: 1;
}

.buttons {
  align-self: flex-end;

  display: flex;
  gap: 0.5rem;
}

.summary {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0.625rem 4.375rem;
  border: 1px solid #1c2d5a;
  border-radius: 14px;

  span {
    font-weight: 700;
    font-size: 0.875rem;
    color: #202224;
  }
}

.main-card {
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .main-form {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .inputs {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      .inputs-row {
        display: flex;
        flex-wrap: wrap;
        gap: 1.5rem;

        .input-full {
          flex: 1;
        }

        .input-processo {
          max-width: 26.625rem;
        }
      }
    }
  }

  .photos-title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
      margin: 0;
      font-weight: 700;
      font-size: 1.5rem;
      color: #202224;
    }
  }
}

.photos-modal {
  width: 80vw;
  display: flex;
  flex-direction: column;
  gap: 2.0625rem;

  .input-default {
    max-width: 13.4375rem;
  }

  .infos {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 1.5rem;
  }

  .actions {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;

    .actions-row {
      display: flex;
      align-items: flex-end;
      gap: 1.5rem;
    }
  }

  .photos {
    display: flex;
    align-items: flex-start;
    gap: 3rem;

    img {
      flex: 1;
      max-width: 25rem;
      border-radius: 10px;
      border: 1px solid #a8a8a8;
    }

    .photos-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 3rem;

      .photos-list {
        padding-right: 1rem;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        max-height: 23.4375rem;
        overflow-y: auto;

        button {
          justify-content: center;
        }

        .list {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 1.5rem;

          img {
            flex: 1;
            max-width: 8.5rem;
          }
        }
      }

      .notifications {
        display: flex;
        align-items: flex-end;
        gap: 1.5rem;
      }
    }
  }
}

.report-modal {
  width: 90vw;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .infos {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
  }
}

.input-bordered {
  border: 1px solid #666 !important;
  color: #080808 !important;
}

.pointer {
  cursor: pointer;
}
.centralizado {
  text-align: center;
}
.avatar {
  position: relative;
}

.teste:hover {
  top: -2px;
  box-shadow: 0 2px 2px #666;
}

.aula {
  border: rgb(134, 129, 129) solid 2px;
  border-radius: 2%;
}
/* On mouse-over, add a deeper shadow */
.card:hover {
  box-shadow: 0 8px 16px 0 rgb(24, 255, 3);
}

/* Add some padding inside the card container */
.container {
  padding: 2px 16px;
}
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 10px; /* 5px rounded corners */
  margin: 5px;
}

/* Add rounded corners to the top left and the top right corner of the image */
.img-monit {
  width: 450px;
  border-radius: 10px 10px 0 0;
}

.img-monit-modal {
  width: 500px;
  height: 500px;
  border-radius: 10px;
}

.img-thumb {
  width: 200px;
  height: 200px;
  border: 1px solid rgba(0, 0, 0, 0.13);
}

#clock {
  font-family: 'Share Tech Mono', monospace;
  color: #080808;
  text-align: center;
}

.size {
  width: 4rem;
  height: 4rem;
}

tr {
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.13);
}

table {
  width: 100%;
}

#monitoramentoFotosTeoricas {
  #modalPhotos {
    .badge {
      cursor: default;
      font-size: 20px;
      padding: 10px 20px;
      background-color: rgb(88, 88, 88) !important;
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: all 0.9s ease;
      overflow: hidden;
      visibility: visible;
      position: absolute;
      width: 100%;
      opacity: 1;
    }

    .fade-enter,
    .fade-leave-to {
      visibility: hidden;
      width: 100%;
      opacity: 0;
    }

    .fa-low-vision {
      font-size: 30px;
      color: white;
      background-color: #dc3545;
      border-color: #dc3545;
      padding: 15px 15px;
      border-radius: 50%;
      box-shadow: black;
      cursor: pointer;
    }

    .fa-low-vision:hover {
      background-color: #dc35467a;
    }

    .modal-lg div.modal-footer {
      display: none !important;
    }
  }
}
</style>
